import store, { moduleActionContext } from '@/store';
import ReconnectingWebSocket from 'reconnecting-websocket';
const state = {
    enabled: false,
    client: null,
    connected: false
};
const getters = {};
const mutations = {
    enable(state, enable) {
        state.enabled = enable;
        localStorage.setItem("streamdeck-enabled", enable ? 'true' : 'false');
        if (enable) {
            state.client = new ReconnectingWebSocket("ws://127.0.0.1:20000");
            state.client.onopen = () => {
                store.commit.streamdeck.setStatus(true);
                store.dispatch.streamdeck.sendCameraToggle(store.state.cameras.autoToggle);
                store.dispatch.streamdeck.sendSelectedCameraId(store.state.cameras.selectedCamera);
            };
            state.client.onclose = () => store.commit.streamdeck.setStatus(false);
            state.client.onerror = () => store.commit.streamdeck.setStatus(false);
            state.client.onmessage = (message) => {
                const data = JSON.parse(message.data);
                if (data.action === 'camera') {
                    store.commit.cameras.setSelectedCamera({ selectedId: data.id, toggle: false });
                }
                if (data.action == "cameraToggle") {
                    store.commit.cameras.setCameraToggle(data.enabled);
                }
            };
        }
        else {
            state.client = null;
            store.commit.streamdeck.setStatus(false);
        }
    },
    setStatus(state, connected) {
        state.connected = connected;
    }
};
const actions = {
    async sendSelectedCameraId(context, selectedCameraId) {
        const { state } = streamdeckModuleActionContext(context);
        if (state.client) {
            const message = JSON.stringify({ selectedCamera: selectedCameraId });
            console.log(message);
            state.client.send(message);
        }
    },
    async sendCameraToggle(context, enabled) {
        const { state } = streamdeckModuleActionContext(context);
        if (state.client) {
            const message = JSON.stringify({ cameraToggle: enabled });
            console.log(message);
            state.client.send(message);
        }
    },
    async enable(context) {
        const { state, commit } = streamdeckModuleActionContext(context);
        if (!state.enabled) {
            commit.enable(true);
        }
    },
    async disable(context) {
        const { state, commit } = streamdeckModuleActionContext(context);
        if (state.enabled) {
            commit.enable(false);
        }
    }
};
const streamdeckModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default streamdeckModule;
export const streamdeckModuleActionContext = (context) => moduleActionContext(context, streamdeckModule);
